import { Box, Skeleton } from "@mui/material";

const PlansLoadingSkeleton = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        gap: "32px",
        width: "100%",
        maxWidth: "1200px",
        padding: "0 16px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: "16px",
          flexWrap: "wrap",
          justifyContent: "start",
        }}
      >
        <Skeleton
          variant="rounded"
          width={220}
          height={36}
          sx={{ borderRadius: "8px", bgcolor: "rgba(35, 114, 185, 0.1)" }}
        />
        <Skeleton
          variant="rounded"
          width={180}
          height={36}
          sx={{ borderRadius: "8px", bgcolor: "rgba(35, 114, 185, 0.1)" }}
        />
        {/* <Skeleton variant="rounded" width={140} height={36} sx={{ borderRadius: '8px', bgcolor: 'rgba(35, 114, 185, 0.1)' }} /> */}
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
          gap: "24px",
          width: "100%",
          maxWidth: "1200px",
        }}
      >
        {[1, 2, 3].map((idx) => (
          <Box
            key={idx}
            sx={{
              p: "24px",
              border: "1.5px solid #DDE4EA",
              borderRadius: "16px",
              display: "flex",
              flexDirection: "column",
              gap: "24px",
              bgcolor: "#FAFAFA",
            }}
          >
            <Skeleton
              variant="text"
              width="50%"
              height={20}
              sx={{ bgcolor: "rgba(35, 114, 185, 0.15)" }}
            />
            <Skeleton
              variant="text"
              width="60%"
              height={48}
              sx={{ bgcolor: "rgba(35, 114, 185, 0.15)" }}
            />
            <Skeleton
              variant="rounded"
              width="100%"
              height={52}
              sx={{ borderRadius: "6px", bgcolor: "rgba(244, 123, 39, 0.2)" }}
            />
            <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              <Skeleton
                variant="text"
                width="90%"
                height={16}
                sx={{ bgcolor: "rgba(35, 114, 185, 0.1)" }}
              />
              <Skeleton
                variant="text"
                width="85%"
                height={16}
                sx={{ bgcolor: "rgba(35, 114, 185, 0.1)" }}
              />
              <Skeleton
                variant="text"
                width="80%"
                height={16}
                sx={{ bgcolor: "rgba(35, 114, 185, 0.1)" }}
              />
            </Box>
            <Skeleton
              variant="rounded"
              width="100%"
              height={80}
              sx={{ borderRadius: "10px", bgcolor: "rgba(35, 114, 185, 0.1)" }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default PlansLoadingSkeleton;
